<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker 
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [withCalendarOnly]="true"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-servicessettings">  
    </smr-stylist-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry 
    *ngIf="errorOccurredWhileLoadingServices || errorOccurredWhileLoadingStylists" 
    (click)="tapToRetry()">
  </salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingServices && !errorOccurredWhileLoadingStylists">

    <smr-all-stylist-service-manager
      *ngIf="showAllStylistServiceManager()"
      [stylist]="stylist"
      >
    </smr-all-stylist-service-manager>   

    <smr-single-stylist-service-manager
      *ngIf="!showAllStylistServiceManager()"
      [stylist]="stylist"
      >
    </smr-single-stylist-service-manager>
  </ng-container>

</ion-content>